import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    header: 'heading-xs mb-5 flex flex-col gap-1',
    headerFirstBlock: 'flex w-full justify-between',
    headerSecondBlock: 'flex w-full justify-between gap-1 max-sm:flex-col',
    authorInfoContainer: 'flex items-center justify-between',
    authorName: 'heading-m font-[450]',
    rating: 'heading-s align-center flex justify-center gap-1 font-[450]',
    date: 'text-text-inactive text-[12px] font-[450]',
    carousel: '[--slide-size:auto] [--slide-spacing:4px]',
    content: 'flex flex-col gap-3',
    star: '[&>path]:fill-brand-400'
  }
});
